import { render, staticRenderFns } from "./suporte-secretarias.vue?vue&type=template&id=9622a43e&scoped=true"
import script from "./suporte-secretarias.vue?vue&type=script&lang=ts"
export * from "./suporte-secretarias.vue?vue&type=script&lang=ts"
import style0 from "./suporte-secretarias.vue?vue&type=style&index=0&id=9622a43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9622a43e",
  null
  
)

export default component.exports